
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';


const InputDateWithFilter = ({ input, placeholder, type, className, beforeInput, afterInput, initvalue, val, min, filterDate, max, meta: { asyncValidating, touched, error } }) => {
  const filterDates = (date) =>{
    if(filterDate){
      return moment(filterDate).format("DD") === moment(date).format("DD")
    }
    return moment()
  }
  return (
    <div className={asyncValidating ? 'async-validating' : ''}>
      <div  >
        {beforeInput}
        <DatePicker  {...input} type={type} autoComplete="off" filterDate={(date) => { return filterDates(date)}} placeholderText={placeholder} className={className} minDate={ min } defaultValue={initvalue} value={val} min={min} max={max}  inputValueFormat="DD/MM/YYYY" dateFormat='DD/MM/YYYY' selected={input.value ? moment(input.value, 'DD/MM/YYYY')  : null} />
        {afterInput}
      </div>
    </div>
  );
}

export default InputDateWithFilter;



// WEBPACK FOOTER //
// ./src/lib/forms/InputDateWithFilter.js